// removed by extract-text-webpack-plugin
module.exports = {"container":"BillFlow__container__1_Ftz","row":"BillFlow__row__31-fB","colLeft":"BillFlow__colLeft__rXrIu","colRight":"BillFlow__colRight__3n0wN","quickPickButton":"BillFlow__quickPickButton__37WL0","loadDataBtn":"BillFlow__loadDataBtn__2NwIT","noLeftMargin":"BillFlow__noLeftMargin__1Llqn","separator":"BillFlow__separator__1pRfc","tableContainer":"BillFlow__tableContainer__2VAue"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/AdminScreens/BillFlow/BillFlow.css
// module id = 571
// module chunks = 0